import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '影视', path: '/category?tab=drama' },
  { name: '音乐', path: '/category?tab=music' },
  { name: '综艺', path: '/category?tab=variety' },
  { name: '资讯', path: '/category?tab=news' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname + location.search === path || location.pathname === path;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-sun-line text-background-50 text-lg"></i>
            </div>
            <span
              className={`font-heading text-xl font-bold transition-colors duration-300 ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              日韩在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 flex items-center justify-center rounded-lg transition-all duration-200 cursor-pointer ${
              scrolled ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/90 text-primary-600 hover:bg-background-50'
              }`}
            >
              加入我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="mt-3 pt-3 border-t border-background-200/70">
              <Link
                to="/about"
                className="block w-full text-center px-4 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer"
              >
                加入我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}